import { Button, Card, Group, List, Stack, Text, Title } from '@mantine/core'
import { IconHome, IconSparkles } from '@tabler/icons-react'

interface FrontpageWelcomeProps {
  onAddPropertyClick: () => void
}

export function FrontpageWelcome({
  onAddPropertyClick,
}: FrontpageWelcomeProps) {
  return (
    <Stack gap="xl" align="center">
      <Stack gap="md" align="center">
        <Group gap="md" align="center" wrap="nowrap">
          <IconHome size={56} color="var(--mantine-color-brandOrange-6)" />
          <Title order={2} style={{ textAlign: 'left' }}>
            Tervetuloa Markku-huoltokirjaan
          </Title>
        </Group>
        <Text size="lg" c="dimmed" maw={600} style={{ textAlign: 'center' }}>
          Pidä huolta kodistasi helposti. Markku auttaa sinua seuraamaan
          kiinteistösi huoltotöitä, säilyttämään tärkeitä dokumentteja ja
          pitämään kodin arvon yllä.
        </Text>
      </Stack>

      <Card radius="md" bg="gray.0" w="100%" maw={700}>
        <Stack gap="lg">
          <Text size="md" fw={600}>
            Huoltokirja auttaa sinua:
          </Text>

          <List
            spacing="md"
            size="md"
            icon={
              <IconSparkles
                size={20}
                color="var(--mantine-color-brandOrange-6)"
              />
            }
          >
            <List.Item>
              <Group gap="sm" wrap="nowrap">
                <div>
                  <Text fw={500}>Seuraamaan vuosihuoltoja</Text>
                  <Text size="sm" c="dimmed">
                    Vuosikello muistuttaa sinua kausikohtaisista huoltotöistä
                  </Text>
                </div>
              </Group>
            </List.Item>

            <List.Item>
              <Group gap="sm" wrap="nowrap">
                <div>
                  <Text fw={500}>Ylläpitämään kiinteistötietoja</Text>
                  <Text size="sm" c="dimmed">
                    Keskitetty paikka kaikille kodin tiedoille ja kuville
                  </Text>
                </div>
              </Group>
            </List.Item>

            <List.Item>
              <Group gap="sm" wrap="nowrap">
                <div>
                  <Text fw={500}>Säilyttämään dokumentteja</Text>
                  <Text size="sm" c="dimmed">
                    Takuut, kuitit ja tärkeät asiakirjat turvassa yhdessä
                    paikassa
                  </Text>
                </div>
              </Group>
            </List.Item>
          </List>
        </Stack>
      </Card>

      <Button
        size="lg"
        radius="md"
        color="brandOrange"
        onClick={onAddPropertyClick}
        w="100%"
        maw={400}
      >
        Aloita lisäämällä kiinteistö
      </Button>
    </Stack>
  )
}
